import React, { useEffect, useState } from 'react'
import ProtectedRoute from '../../routes/protected'
import SidebarCargosSalarios from '../../components/sidebars/sidebarCargosSalarios'
import salaryAnalysisService from '../../services/data/salary-analysis.service'
import currencyFormat from '../../helpers/currencyFormat'

export default function AnaliseSubempresa() {
    const [suborgs, setSuborgs] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')

    useEffect(() => {
        salaryAnalysisService.listSubempresas()
            .then(setSuborgs)
            .catch(e => setError(JSON.stringify(e?.response?.data || e)))
            .finally(() => setLoading(false))
    }, [])

    return (
        <ProtectedRoute>
            <div className="container-fluid">
                <div className='row flex-nowrap'>
                    <SidebarCargosSalarios />
                    <div className="col-xs-10 col-sm-9 col-md-9 col-xl-10 p-0 formMarginBottom">
                        <div className='col text-bg-green p-3'>
                            <span className="fs-6 fw-bold">Análise por Organização</span>
                        </div>

                        {error && <div className='alert alert-danger m-3'>{error}</div>}

                        {loading && (
                            <div className='text-center p-5'>
                                <div className="spinner-border text-success" role="status" />
                            </div>
                        )}

                        {!loading && suborgs.length === 0 && (
                            <p className='text-center text-muted p-5'>Nenhuma organização encontrada.</p>
                        )}

                        {!loading && suborgs.length > 0 && (
                            <>
                                {/* Comparativo gráfico simplificado */}
                                <div className='row m-3'>
                                    <div className='col bg-white border-clean pb-4 pt-3'>
                                        <h6 className='fw-bold mb-3'>Comparativo de Massa Salarial por Organização</h6>
                                        {(() => {
                                            const maxMass = Math.max(...suborgs.map(s => s.total_salary_mass), 1)
                                            return suborgs.map((sub, i) => (
                                                <div key={i} className='mb-3'>
                                                    <div className='d-flex justify-content-between small mb-1'>
                                                        <span className='fw-bold'>{sub.subcompany_title}</span>
                                                        <span>{currencyFormat(sub.total_salary_mass)}</span>
                                                    </div>
                                                    <div className='progress' style={{height: 10}}>
                                                        <div className='progress-bar bg-success'
                                                            style={{width: `${(sub.total_salary_mass / maxMass) * 100}%`}} />
                                                    </div>
                                                </div>
                                            ))
                                        })()}
                                    </div>
                                </div>

                                {/* Cards por organização */}
                                <div className='row m-3 g-3'>
                                    {suborgs.map((sub, i) => (
                                        <div key={i} className='col-md-6 col-xl-4'>
                                            <div className='card border-clean h-100'>
                                                <div className='card-body'>
                                                    <h6 className='fw-bold'>{sub.subcompany_title}</h6>
                                                    <hr className='my-2' />
                                                    <div className='row text-center g-2 mb-3'>
                                                        <div className='col-4'>
                                                            <div className='text-muted small'>Posições</div>
                                                            <div className='fw-bold'>{sub.total_expected_positions}</div>
                                                        </div>
                                                        <div className='col-4'>
                                                            <div className='text-muted small'>Colaboradores</div>
                                                            <div className='fw-bold text-success'>{sub.total_headcount}</div>
                                                        </div>
                                                        <div className='col-4'>
                                                            <div className='text-muted small'>Massa Sal.</div>
                                                            <div className='fw-bold small'>{currencyFormat(sub.total_salary_mass)}</div>
                                                        </div>
                                                    </div>

                                                    {Object.keys(sub.grade_distribution).length > 0 && (
                                                        <>
                                                            <div className='small fw-bold text-muted mb-2'>Distribuição por Grau</div>
                                                            {Object.entries(sub.grade_distribution).map(([grade, count], gi) => (
                                                                <div key={gi} className='d-flex justify-content-between small mb-1'>
                                                                    <span>Grau {grade}</span>
                                                                    <span className='badge bg-light text-dark border'>{count} colaboradores</span>
                                                                </div>
                                                            ))}
                                                        </>
                                                    )}

                                                    {sub.active_structures.length > 0 && (
                                                        <>
                                                            <div className='small fw-bold text-muted mt-2 mb-1'>Estruturas Ativas</div>
                                                            {sub.active_structures.map((s, si) => (
                                                                <span key={si} className='badge bg-light text-dark border me-1'>{s.title}</span>
                                                            ))}
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </ProtectedRoute>
    )
}
